document.addEventListener('DOMContentLoaded', function() {
  const data = document.getElementById('product-metafields-data');
  if (!data) return;

  const cards = document.querySelectorAll('.multicolumn-card');
  cards.forEach(function(card, index) {
    const i = index + 1;
    const titulo = data.getAttribute('data-col' + i + '-titulo');
    const descripcion = data.getAttribute('data-col' + i + '-descripcion');

    if (titulo) {
      const h = card.querySelector('.multicolumn-card__info .heading');
      if (h) h.textContent = titulo;
    }
    if (descripcion) {
      const p = card.querySelector('.multicolumn-card__info .rte');
      if (p) p.innerHTML = '<p>' + descripcion + '</p>';
    }
  });
});
